// Generated types for VersioningRelease
// This file is auto-generated - do not edit manually

import { z } from 'zod';

import { VersioningRowReadAPI, VersioningRowWriteAPI } from './versioningrow';
import { VersioningRowReadAPISchemaObject, VersioningRowWriteAPISchemaObject } from './versioningrow';

// ============================================================================
// TypeScript Interfaces
// ============================================================================

export interface VersioningReleaseReadAPI extends Omit<VersioningRowReadAPI, 'created_at'> {
  /** Server-clock tag time (ms). */
  created_at?: number | null;
  /** The island root's id. */
  island_id: string;
  /** Release name (unique per island). */
  name: string;
  /** The tagged commit; the seal defaults it to the island's main head at creation. */
  commit_id?: string | null;
  /** Tagging actor (server-set). */
  created_by?: string;
  /** Optional release note. */
  note?: string;
}

export interface VersioningReleaseWriteAPI extends VersioningRowWriteAPI {
  /** Server-clock tag time (ms). */
  created_at?: number | null;
  /** The island root's id. */
  island_id: string;
  /** Release name (unique per island). */
  name: string;
  /** The tagged commit; the seal defaults it to the island's main head at creation. */
  commit_id?: string | null;
  /** Tagging actor (server-set). */
  created_by?: string;
  /** Optional release note. */
  note?: string;
}

// ============================================================================
// Zod Schemas
// ============================================================================

export const VersioningReleaseReadAPISchema: z.ZodType<VersioningReleaseReadAPI> = VersioningRowReadAPISchemaObject.omit({ 'created_at': true }).extend({
  created_at: z.number().nullable().optional(),
  island_id: z.string(),
  name: z.string(),
  commit_id: z.string().nullable().optional(),
  created_by: z.string().optional(),
  note: z.string().optional(),
}).passthrough();

export const VersioningReleaseWriteAPISchema: z.ZodType<VersioningReleaseWriteAPI> = VersioningRowWriteAPISchemaObject.extend({
  created_at: z.number().nullable().optional(),
  island_id: z.string(),
  name: z.string(),
  commit_id: z.string().nullable().optional(),
  created_by: z.string().optional(),
  note: z.string().optional(),
}).passthrough();
